import { Reveal } from "@/components/Reveal";
import { getShowStatus } from "@/data/content";

export default function ShowCard({ show, index = 0, onOpen }) {
    const status = getShowStatus(show.slug);
    return (
        <Reveal delay={(index % 4) * 0.07} className="h-full">
            <button
                type="button"
                data-testid={`show-card-${show.slug}`}
                onClick={() => onOpen?.(show)}
                className="group relative flex h-full w-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#16162B] text-left transition-colors duration-300 hover:border-[#C8102E]/60"
            >
                <div className="relative aspect-video w-full overflow-hidden">
                    <img
                        src={show.img}
                        alt={show.title}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F23]/85 via-transparent to-transparent" />
                    <span className="absolute left-3 top-3 rounded-full bg-[#C8102E] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-white">
                        {show.category}
                    </span>
                    {status?.type === "live" && (
                        <span data-testid={`show-live-${show.slug}`} className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-[#0F0F23]/80 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-[#E85050] backdrop-blur">
                            <span className="onair-dot h-1.5 w-1.5 rounded-full bg-[#C8102E]" /> Live
                        </span>
                    )}
                </div>
                <div className="flex flex-1 flex-col gap-1 p-5">
                    <h3 className="font-display text-lg font-bold text-white transition-colors duration-300 group-hover:text-[#FFA200]">
                        {show.title}
                    </h3>
                    <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#9999BB]">
                        {show.days} · <span className="text-[#FFA200]">{show.time}</span>
                    </p>
                    {status && status.type !== "live" && (
                        <p data-testid={`show-status-${show.slug}`} className={`mt-2 text-[11px] font-semibold ${status.type === "upcoming" ? "text-[#FFA200]" : "text-[#9999BB]"}`}>
                            {status.label}
                        </p>
                    )}
                </div>
            </button>
        </Reveal>
    );
}
